import React from "react";

const ProfileHeader = ({title, subHeading}) => {
  return (
    <div className="header-section">
      <h2 className="component-title">{title}</h2>
      <p className="component-subtitle">
        {subHeading}
      </p>
    </div>
  );
};

export default ProfileHeader;